// @flow
import * as React from 'react';

import { Checkbox, Switch } from './styles.js';

import { noop } from 'lodash/fp';

type Props = {
    isOn: boolean,
    name?: string,
    onChange: noop
};

const ToggleButton = ({ isOn, name, onChange }: Props) => (
    <div>
        <label>
            <Checkbox checked={isOn} name={name} onChange={onChange} type="checkbox" />
            <Switch isOn={isOn} />
        </label>
    </div>
);

export default ToggleButton;



// WEBPACK FOOTER //
// ./src/components/widgets/buttons/toggle/index.js